export const version = '1.4.2';
//# sourceMappingURL=version.js.map